/**
 * 狭い画面でのメニューの開閉。
 *
 * ビュー側の約束:
 *   [data-nav-toggle]  押すと開閉するボタン。aria-expanded を持つ
 *   [data-nav-panel]   開閉される中身
 *
 * 表示・非表示は Tailwind の hidden で切り替える。
 * 広い画面では lg:flex が効くため、hidden が付いていても畳まれない。
 */
export const setupNavToggle = (root: ParentNode = document): void => {
    const toggle = root.querySelector<HTMLElement>("[data-nav-toggle]");
    const panel = root.querySelector<HTMLElement>("[data-nav-panel]");
    if (toggle === null || panel === null) {
        return;
    }

    toggle.addEventListener("click", () => {
        const opened = panel.classList.toggle("hidden");
        // hidden が付いた = 閉じた
        toggle.setAttribute("aria-expanded", String(!opened));
    });
};
